<div class="page-with-shadow">
    <app-page-header 
        [title]="pageTitle" 
        [description]="pageDescription"> 
    </app-page-header>

    <form (ngSubmit)="onSubmit()" #poForm="ngForm" class="col">
        <app-po-template
            [purchaseOrder]="purchaseOrder"
            [allowMultiple]="true"
            (isValidChanged)="isValidChanged($event)">
        </app-po-template>

        <div class="d-flex justify-content-end">
            <button type="button" 
                class="btn btn-default" 
                (click)="onCancel()">
                Cancel
            </button>
            <button type="submit" 
                class="btn btn-primary margin-left-md" 
                [disabled]="!isValid">
                Create new PO
            </button>
        </div>
    </form>
</div>